import { Globe, Share, Plus, MoreVertical } from 'lucide-react';

const detectPlatform = () => {
  const ua = navigator.userAgent || '';
  if (/iPad|iPhone|iPod/.test(ua)) return 'ios';
  if (/Android/.test(ua)) return 'android';
  return 'other';
};

export const HomeScreenInstructions = () => {
  const platform = detectPlatform();
  return (
    <div className="text-left rounded-xl border border-violet-200 dark:border-violet-800 bg-violet-50/60 dark:bg-violet-900/20 p-4 space-y-2" data-testid="home-screen-instructions">
      <p className="text-sm font-semibold flex items-center gap-2 text-violet-700 dark:text-violet-300">
        <Globe className="w-4 h-4" /> Add it to your Home Screen
      </p>
      <p className="text-xs text-muted-foreground">
        For one-tap access that feels just like a regular app:
      </p>

      {(platform === 'ios' || platform === 'other') && (
        <div className="text-xs text-slate-700 dark:text-slate-300" data-testid="home-instructions-ios">
          <p className="font-medium mt-1">On iPhone / iPad (Safari):</p>
          <p className="flex items-center gap-1 flex-wrap">
            Tap <Share className="w-3.5 h-3.5 inline" /> <b>Share</b>, then choose
            <span className="inline-flex items-center gap-1"><Plus className="w-3.5 h-3.5 inline" /> <b>Add to Home Screen</b></span>.
          </p>
        </div>
      )}
      {(platform === 'android' || platform === 'other') && (
        <div className="text-xs text-slate-700 dark:text-slate-300" data-testid="home-instructions-android">
          <p className="font-medium mt-1">On Android (Chrome):</p>
          <p className="flex items-center gap-1 flex-wrap">
            Tap <MoreVertical className="w-3.5 h-3.5 inline" /> <b>menu</b>, then
            <b>Add to Home screen</b>.
          </p>
        </div>
      )}
    </div>
  );
};

export default HomeScreenInstructions;
